export default {"src":"/_next/static/media/ic-multiple-choices.75945229.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};